import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchWorkoutPlanList = async ({ coachId, clientId }) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_WORKOUT_LIST}/${coachId}/${clientId}`
    );
    return await response.data;
  } catch (error) {
    throw new Error(
      error.response?.data || "Failed to fetch workout plan detail"
    );
  }
};
